import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/wifi.vue'
wx.createPage(MiniProgramPage)